module.exports = __webpack_public_path__ + "static/media/b1.d42ef6a1.png";